export default {
  recordTitle: '提现记录',
  empty: '该筛选下暂无提现记录',
  filterType: '提现类型',
  filterStatus: '提现状态',
  st: {
    all: '全部',
    ok: '已到账',
    pend: '处理中',
    rej: '已驳回',
    cancel: '已撤销',
  },
  detailAccount: '到账账户',
  cancel: '撤销提现(原路退回)',
  cancelling: '正在撤销…',
  cancelOk: '已撤销,资金已原路退回',
  resubmit: '重新提交',
  resubmitToast: '已带入原信息,请核对收款账户后重新提交',
  cryptoPending: '审核中,通过后链上广播',
}
